import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import whatsappIcon from '../../assets/images/wats.png';
import telegramIcon from '../../assets/images/tg.png';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h3 className="footer-title">МИГРАНТ PRO</h3>
              <p className="footer-description">
                Профессиональная помощь в решении миграционных вопросов в Москве и Московской области.
              </p>
              <div className="social-links">
                <a href="https://wa.me/79257166607" target="_blank" rel="noopener noreferrer" className="social-link">
                  <img src={whatsappIcon} alt="WhatsApp" />
                </a>
                <a href="https://t.me/migrant_pro_1/646" target="_blank" rel="noopener noreferrer" className="social-link">
                  <img src={telegramIcon} alt="Telegram" />
                </a>
              </div>
            </div>

            <div className="footer-column">
              <h4 className="footer-subtitle">Навигация</h4>
              <ul className="footer-links">
                <li><a href="#services">Услуги</a></li>
                <li><a href="#reviews">Отзывы</a></li>
                <li><a href="#footer-contacts">Контакты</a></li>
                <li><Link to="/privacy">Политика конфиденциальности</Link></li>
              </ul>
            </div>

            <div className="footer-column" id="footer-contacts">
              <h4 className="footer-subtitle">Контакты</h4>
              <div className="footer-contacts">
                <div className="contact-item">
                  <MapPin size={18} />
                  <div>
                    <p className="contact-label">Офис 1:</p>
                    <p>г. Москва, 1 микрорайон московский д.39, к.1 (2 этаж)</p>
                  </div>
                </div>
                <div className="contact-item">
                  <MapPin size={18} />
                  <div>
                    <p className="contact-label">Офис 2:</p>
                    <p>Московская область, Подольск, пр-д Авиаторов, д. 1 ТЦ "МОЛОТОК", 2 этаж, павильон А-59</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Phone size={18} />
                  <a href="tel:+79257166607">+7 (925) 716-66-07</a>
                </div>
                <div className="contact-item">
                  <Mail size={18} />
                  <a href="mailto:9252461666@ya.ru">9252461666@ya.ru</a>
                </div>
                <div className="contact-item">
                  <Clock size={18} />
                  <div>
                    <p>Пн - Чт: 09:00—18:00</p>
                    <p>Пт: 09:00—17:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>© {currentYear} Мигрант PRO. Все права защищены.</p>
            <p className="footer-inn">Демиденко Р. А. ИНН 301302995994</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;